const questions = [
  {
    id: 1,
    name: 'atendimento',
    text: 'Como foi o seu atendimento na imobiliária?',
    options: [
      {
        value: 'Nada Satisfeito',
        label: '1. Nada Satisfeito',
      },
      {
        value: 'Pouco Satisfeito',
        label: '2. Pouco Satisfeito',
      },
      {
        value: 'Moderadamente satisfeito',
        label: '3. Moderadamente satisfeito',
      },
      {
        value: 'Muito satisfeito',
        label: '4. Muito satisfeito',
      },
      {
        value: 'Extremamente satisfeito',
        label: '5. Extremamente satisfeito',
      },
    ],
  },
  {
    id: 2,
    name: 'agilidade',
    text: 'Como foi a agilidade do serviço prestado pela CredPago?',
    options: [
      {
        value: 'Nada ágil',
        label: '1. Nada ágil',
      },
      {
        value: 'Pouco ágil',
        label: '2. Pouco ágil',
      },
      {
        value: 'Muito ágil',
        label: '3. Muito ágil',
      },
      {
        value: 'Extremamente ágil',
        label: '4. Extremamente ágil',
      },
    ],
  },
  {
    id: 3,
    name: 'indicar',
    text: 'Qual a chance de indicar a CredPago para um amigo/familiar?',
    options: [
      {
        value: 'Não indicaria',
        label: '1. Não indicaria',
      },
      {
        value: 'Talvez indicaria',
        label: '2. Talvez indicaria',
      },
      {
        value: 'Com certeza indicaria',
        label: '3. Com certeza indicaria',
      },
    ],
  },
];

export default questions;
